module.exports = __webpack_public_path__ + "img/renshou.bce0aa7d.jpg";